import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { Typography, List, ListItem, ListHeader, Select, Skeleton } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { useMobile } from 'shared/domains/common-ui';
import { useComposerData } from '../../../ComposerDataProvider';
export function Templates() {
    const { templatesAmount, templatesFilter, setTemplatesFilter, loading } = useComposerData();
    const isMobile = useMobile();
    const filters = [
        {
            label: <Trans comment="Select template dialog - Browse company templates filter label">My company&apos;s</Trans>,
            icon: <Falcon icon="building"/>,
            filterKey: 'templates:company',
        },
        {
            label: <Trans comment="Select template dialog - Browse all templates filter label">Browse all</Trans>,
            icon: <Falcon icon="search"/>,
            filterKey: 'templates:all',
        },
        {
            label: (<Trans comment="Select template dialog - Browse only included plans filter label">Included in my plan</Trans>),
            icon: <Falcon icon="circle-check"/>,
            filterKey: 'templates:included',
        },
    ];
    const title = t({
        message: 'Templates',
        comment: 'Select template dialog - Templates label',
    });
    if (isMobile) {
        return (<Select value={templatesFilter} onChange={(e) => setTemplatesFilter(e.target.value)}>
        {filters.map(({ label, filterKey }) => (<option selected={templatesFilter === filterKey} key={filterKey} value={filterKey}>
            {label}
          </option>))}
      </Select>);
    }
    return (<section>
      <Skeleton loading={loading}>
        <ListHeader title={title}/>
      </Skeleton>
      <List as="nav">
        {filters.map(({ icon, label, filterKey }) => (<Skeleton loading={loading} key={filterKey}>
            <ListItem as="button" type="button" selected={templatesFilter === filterKey} onClick={() => setTemplatesFilter(filterKey)} action={<Typography $fontSize="small" $appearance="100">
                  {templatesAmount[filterKey]}
                </Typography>}>
              {icon}
              {label}
            </ListItem>
          </Skeleton>))}
      </List>
    </section>);
}
